import styled from 'styled-components'

const SecondaryColumnHeaderRow = styled.div`
  position: relative;
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 0 24px;
`

SecondaryColumnHeaderRow.displayName = 'SecondaryColumnHeaderRow'
export default SecondaryColumnHeaderRow
